import * as Yup from 'yup';

export const KycDirectorTwoSchema = Yup.object().shape({
  // taxIdentificationNumber: Yup.string()
  //   .min(1, 'Tax Identification Number is required')
  //   .required('Please provide your Tax Identification Number'),
  directorTwoName: Yup.string()
    .test(
      'all-or-nothing',
      'If any Director 2 field is filled, all fields must be completed',
      function (value) {
        const { directorTwoIdentificationType, directorTwoId } = this.parent;
        const hasAnyValue = value || directorTwoIdentificationType || (directorTwoId && directorTwoId.length > 0);

        if (!hasAnyValue) return true; // All empty is valid
        return !!value && value.length > 0; // If any filled, this must be filled
      }
    ),
  directorTwoIdentificationType: Yup.string()
    .test(
      'all-or-nothing',
      'If any Director 2 field is filled, all fields must be completed',
      function (value) {
        const { directorTwoName, directorTwoId } = this.parent;
        const hasAnyValue = directorTwoName || value || (directorTwoId && directorTwoId.length > 0);

        if (!hasAnyValue) return true; // All empty is valid
        return !!value && value.length > 0; // If any filled, this must be filled
      }
    ),
  directorTwoId: Yup.array()
    .of(
      Yup.mixed<File>()
        .test('fileType', 'Unsupported file format', (file: File | undefined) =>
          file
            ? [
              'application/pdf',
              'application/msword',
              'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            ].includes(file.type)
            : false
        )
        .test(
          'fileSize',
          'File size too large (Max: 15MB)',
          (file: File | undefined) =>
            file ? file.size <= 15 * 1024 * 1024 : false
        )
    )
    .test(
      'all-or-nothing',
      'If any Director 2 field is filled, all fields must be completed',
      function (value) {
        const { directorTwoName, directorTwoIdentificationType } = this.parent;
        const hasAnyValue = directorTwoName || directorTwoIdentificationType || (value && value.length > 0);

        if (!hasAnyValue) return true; // All empty is valid
        return !!value && value.length > 0; // If any filled, this must be filled
      }
    ),
});

export type KycDirectorTwoDataType = Yup.InferType<typeof KycDirectorTwoSchema>;

type InitialValues = {
  // taxIdentificationNumber: string;
  directorTwoName: string;
  directorTwoIdentificationType: string;
  directorTwoId: File[];
};

export const kycDirectorTwoInitialValues: InitialValues = {
  // taxIdentificationNumber: '',
  directorTwoName: '',
  directorTwoIdentificationType: '',
  directorTwoId: [],
};


export interface KycDirectorTwoInterface {
  directorTwoName?: string;
  directorTwoIdentificationType?: string;
  directorTwoId?: File[];
};

